<template>
  <main class="rh-auth">
    <section class="rh-panel">
      <img :src="logo" alt="MetaVirtue" />
      <slot />
    </section>
  </main>
</template>

<script>
import logo from '@/assets/rh_logo.png'

export default {
  name: 'RhPainelAcesso',
  data() {
    return { logo }
  },
}
</script>

<style>
.rh-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f4f3f0, #bfddf5);
  padding: 24px;
  font-family: Montserrat, Arial, sans-serif;
}
.rh-auth .rh-panel {
  background: #fff;
  border-radius: 22px;
  padding: 40px;
  width: min(100%, 480px);
  box-shadow: 0 25px 70px rgba(11, 26, 62, 0.12);
}
.rh-auth .rh-panel > img {
  width: 220px;
  margin-bottom: 32px;
}
.rh-auth .rh-panel h1 {
  font-size: 29px;
  color: #0b1a3e;
  font-weight: 800;
  margin: 8px 0;
}
.rh-auth .rh-panel p {
  color: #667085;
  margin-bottom: 24px;
}
.rh-auth .rh-kicker {
  letter-spacing: 0.14em;
  color: #0e8fa8 !important;
  font-size: 11px;
  font-weight: 800;
}
.rh-auth .rh-panel .button.is-primary {
  background: #007bff;
  border-color: #007bff;
  font-weight: 700;
}
.rh-auth .rh-back {
  display: block;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
  font-weight: 700;
}
.rh-auth .rh-ok {
  color: #0e8fa8;
}
@media (max-width: 520px) {
  .rh-auth .rh-panel {
    padding: 28px;
  }
}
</style>
